// extracted by mini-css-extract-plugin
module.exports = {"icon":"inviteeStatusMessage_icon__RazOi","info":"inviteeStatusMessage_info__9s6_A","card":"inviteeStatusMessage_card__490tK","compliance":"inviteeStatusMessage_compliance__880eh"};